import React, { ReactElement } from 'react';
import { FormGroup, Input, Label } from 'reactstrap';
import { FormNodeLinkTermsAgreementModel } from '../../../../../shared/kiosk';
import { AbstractElementEditor, UpdateFormProps } from './AbstractElementEditor';

export class LinkTermsAgreementEditor extends AbstractElementEditor<FormNodeLinkTermsAgreementModel> {
  public getDescription(): string {
    return 'Link to terms page';
  }

  public getName(): string {
    return 'Link to terms page';
  }

  public getIcon(): string {
    return 'text_snippet';
  }

  public override getDefaultValues(): Partial<
    Omit<FormNodeLinkTermsAgreementModel, 'id' | 'type'>
  > {
    return {
      markdown: 'Do you agree to the [terms](https://concat.app/)?',
    };
  }

  public override getUpdateForm({
    node,
    update,
  }: UpdateFormProps<FormNodeLinkTermsAgreementModel>): ReactElement {
    return (
      <FormGroup>
        <Label for="markdown">Markdown</Label>
        <Input
          onChange={(e) => {
            update({ ...node, markdown: e.target.value });
          }}
          rows={15}
          type="textarea"
          value={node.markdown}
        />
      </FormGroup>
    );
  }
}
